import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

/**
 * Allows activation only for a live Identity session.
 *
 * No session ⇒ the visitor leaves for the Identity sign-in page carrying a login intent
 * for the URL they asked for, so they land back here after signing in. A signed-in user
 * without CRM access goes to Identity's access-denied page. When Identity is unreachable
 * we fall back to the persisted session so a blip does not bounce the user out.
 */
export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const status = await authService.ensureSession();

  if (status === 'active') {
    return true;
  }

  if (status === 'offline') {
    return authService.isAuthenticated();
  }

  if (status === 'denied') {
    authService.redirectToIdentityAccessDenied();
    return false;
  }

  await authService.redirectToIdentityLogin();
  return false;
};
